let linksHash = $('a[href^="#"]');
const siteHeader = $('.c-site-header');


let urlPage = window.location.href;
if (urlPage.split('#')[1]) {
    let idLinkPage = $('#' + $.escapeSelector(urlPage.split('#')[1]));

    $(window).on('load', function () {
        $('html, body').animate({
            scrollTop: idLinkPage.offset().top - siteHeader.outerHeight()
        });
    });
}


if (linksHash.length) {
    $(document).on('click', 'a[href^="#"] ', function (e) {
        let targetLink = $(this).attr('href');
        if (targetLink.length === 1 || targetLink === '#modal-turbo') return 
        let scrollTopTarget;
        scrollTopTarget = $(targetLink).offset().top - siteHeader.outerHeight(); 
        
        $('html, body').animate({
            scrollTop: scrollTopTarget
        }, function () {
            if ($(targetLink).is('select, input, textarea, button, a')) {
                $(targetLink).focus();
            } else {
                $(targetLink).css('outline-offset', '-2px').attr('tabindex', -1).focus();
            }
        });
    });
}

jQuery(function () {
if(window.location.hash) {
    var hash = window.location.hash.substring(1);
    $([document.documentElement, document.body]).animate({
        scrollTop: $("h2."+hash).offset().top - jQuery("header").outerHeight()
    }, 2000);
  } else { 
    // Fragment doesn't exist 
  } 
});
